document.addEventListener("DOMContentLoaded", () => {
  const trigger = document.querySelector(".link-text.contact-form-show");
  const form = document.querySelector(".contact-form");

  // Wieder aktiv (stand auskommentiert): ohne Formular-Reiter wuerde das
  // Skript unten mit einem Fehler abbrechen.
  if (!trigger || !form) return;

  // The clickable area is the whole .link-text.contact-form-show div
  trigger.addEventListener("click", () => {
    toggleForm();
  });

  function toggleForm() {
    trigger.classList.toggle("active");

    if (form.classList.contains("open")) {
      slideUp(form);
    } else {
      slideDown(form);
    }
  }

  function slideDown(el, duration = 400) {
    if (el.classList.contains("animating")) return;
    el.classList.add("animating", "open");

    el.style.removeProperty("display");
    let display = window.getComputedStyle(el).display;
    if (display === "none") display = "block";
    el.style.display = display;

    /*
     * Zwei Fehler, beide 02.10.2026 behoben:
     *
     * 1. Die Zielhoehe stand in REM statt in PX. scrollHeight liefert Pixel —
     *    aus 407 px wurden 407rem, also rund 6.500 px.
     * 2. Aufgeraeumt wurde per requestAnimationFrame, also nach EINEM Bild.
     *    Damit war die Hoehe weg, bevor die Animation laufen konnte, und das
     *    Formular ploppte schlagartig auf, statt aufzuklappen.
     *
     * Jetzt: Pixel, und aufgeraeumt wird erst nach Ablauf der Animation —
     * genau wie slideUp() darunter es schon immer gemacht hat.
     */
    const height = el.scrollHeight;
    el.style.overflow = "hidden";
    el.style.height = "0px";
    el.offsetHeight; // force reflow
    el.style.transition = `height ${duration}ms ease`;
    el.style.height = height + "px";

    setTimeout(() => {
      el.classList.remove("animating");
      el.style.removeProperty("height");
      el.style.removeProperty("overflow");
      el.style.removeProperty("transition");
      inSichtHolen(el);
    }, duration);
  }

  /*
   * Nach dem Aufklappen den Anfang des Formulars ins Bild holen — aber nur,
   * wenn er nicht ohnehin zu sehen ist. Die Kopfleiste ist sticky und liegt
   * ueber dem Inhalt, deshalb wird ihre Hoehe abgezogen.
   */
  function inSichtHolen(el) {
    const kopf = document.querySelector(".section-header");
    const oben = kopf ? Math.max(0, kopf.getBoundingClientRect().bottom) : 0;
    const r = el.getBoundingClientRect();
    if (r.top >= oben && r.top <= window.innerHeight - 120) return;
    const ruhig = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: window.scrollY + r.top - oben - 16, behavior: ruhig ? "auto" : "smooth" });
  }

  function slideUp(el, duration = 400) {
    if (el.classList.contains("animating")) return;
    el.classList.add("animating");

    el.style.height = el.scrollHeight + "px";
    el.style.overflow = "hidden";
    el.offsetHeight; // force reflow
    el.style.transition = `height ${duration}ms ease`;
    el.style.height = "0px";

    setTimeout(() => {
      el.classList.remove("animating", "open");
      el.style.display = "none";
      el.style.removeProperty("height");
      el.style.removeProperty("overflow");
      el.style.removeProperty("transition");
    }, duration);
  }

  // open trigger Melibo Live chat widget

  // ✅ Close form when clicking other buttons
  document.querySelectorAll('.link-text:not(.contact-form-show)').forEach(btn => {
    btn.addEventListener('click', () => form.classList.contains("open") && (slideUp(form), trigger.classList.remove("active")));
  });

  // open trigger Melibo Live chat widget

  const meliboBtn = document.getElementById('trigger-melibo-chat');

  if (meliboBtn) {
    meliboBtn.addEventListener('click', function () {
      if (window.melibo && typeof window.melibo.openWidget === 'function') {
        window.melibo.openWidget();
      }
    });
  }


});

